export default __webpack_public_path__ + "c5eb010e05e13e725b61225aa35d8b0f.png";